import { render } from "./AdicionarCarrinho.vue?vue&type=template&id=4825af4f&scoped=true"
import script from "./AdicionarCarrinho.vue?vue&type=script&lang=js"
export * from "./AdicionarCarrinho.vue?vue&type=script&lang=js"

import "./AdicionarCarrinho.vue?vue&type=style&index=0&id=4825af4f&lang=scss"
import "./AdicionarCarrinho.vue?vue&type=style&index=1&id=4825af4f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4825af4f"]])

export default __exports__